export const INTEGRATIONTYPES = {
  INSTAGRAM: 'instagram',
  FACEBOOK: 'facebook',
  WHATSAPP: 'whatsapp',
  SHOPIFY: 'shopify',
}
